import { render, staticRenderFns } from "./ChinaInformationV2.vue?vue&type=template&id=6f550b72"
import script from "./ChinaInformationV2.vue?vue&type=script&lang=js"
export * from "./ChinaInformationV2.vue?vue&type=script&lang=js"
import style0 from "./ChinaInformationV2.vue?vue&type=style&index=0&id=6f550b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports